import React, {useEffect, useState} from 'react'
import backgroundImg from '../ui/backdrop_archive.png'
import ArAppAd from '../core/ArAppAd';
import Search from './forms/Search';
// import NameBox from '../core/NameBox';


const Archive = () => {

  const [loading, setLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error state

  const [names, setNames] = useState([]);
  // const [selectedName, setSelectedName] = useState(null);

  useEffect(() => {
    // Define an async function to fetch data
    const fetchData = async () => {
        try {
            const response = await fetch('https://aufarbeitung-kampnagel.de/api/names'); // Fetch data from endpoint
            if (!response.ok) {
                throw new Error('Failed to fetch data');
            }
            const result = await response.json(); // Parse JSON data
            setNames(result); // Set data to state
            // console.log('found '+result.length+' names')
        } catch (error) {
            setError(error.message+'test'); // Set error message if any
        } finally {
            setLoading(false); // Set loading to false when data is fetched
        }
    };

    fetchData();
}, []); // Empty dependency array to run only on mount

if (loading) return <p>Loading...</p>;
if (error) return <p>Error: {error}</p>;

  return (
    <>


      <div id='backdropContainer'>

        <img src={backgroundImg} alt="Ein Bild mit Kaleidoskopmuster" id='Backdrop' />
      </div>


      <div className='serachform'>


        

      



        <Search allNames={names}></Search>

        {/* <NameBox allNames={names}></NameBox > */}
 
      </div>







      <ArAppAd></ArAppAd>

    </>
  )
}

export default Archive